import { useQuery } from 'react-query';

import { getTrapDetailTimeLineChartData } from 'api/traps/Trap/getTrapDetailTimeLineChartData';

export const useGetTrapDetailTimeLineChartData = (slug: string, type: string) => {
  const { data, refetch, isLoading, isFetching } = useQuery(
    'TrapDetailTimeLineChartData',
    () => getTrapDetailTimeLineChartData(slug, type),
    {
      refetchOnWindowFocus: false,
    },
  );

  return { data, refetch, isLoading, isFetching };
};

export default useGetTrapDetailTimeLineChartData;
